"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugFactory = void 0;
/* Portions of this file inspired by https://github.com/debug-js/debug/
and used under MIT license: https://github.com/debug-js/debug/blob/f66cb2d9f729e1a592e72d3698e3b75329d75a25/LICENSE */
const lru_cache_1 = require("lru-cache");
const colors_1 = require("./colors");
const local_storage_1 = require("./local-storage");
const LOG_LEVEL = ["debug", "error"];
const ERROR_LOG_LEVEL = LOG_LEVEL.indexOf("error");
const isLogNamespaceEnabled = (ns, config) => {
    const patterns = (local_storage_1.localStorage.getDebugConfig() || config.DEBUG).split(";");
    let enabled = false;
    for (const pattern of patterns) {
        const negate = pattern[0] === "-";
        const regex = new RegExp(`^${pattern.slice(negate ? 1 : 0).replaceAll("*", ".*")}$`);
        if (regex.test(ns)) {
            if (negate) {
                // One matching negation pattern will cancel any matching enable patterns.
                return false;
            }
            enabled = true;
        }
    }
    return enabled;
};
function selectColor(namespace) {
    let hash = 0;
    for (let i = 0; i < namespace.length; i++) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return colors_1.COLORS[Math.abs(hash) % colors_1.COLORS.length];
}
const lastCallTimestamps = new lru_cache_1.LRUCache({
    max: 2000,
    ttl: 3600000, // one hour
});
const namespaceDelimiter = ":";
const debugFactory = (namespace, config, options) => {
    const enabled = isLogNamespaceEnabled(namespace, config);
    const namespaceColor = selectColor(namespace);
    const extend = (ns, extendOptions) => debugFactory(`${namespace}${ns.length ? namespaceDelimiter : ""}${ns}`, config, Object.assign(Object.assign({}, options), extendOptions));
    const jsonFormatter = (message, diffMs, ...logArgs) => [
        JSON.stringify({
            namespace,
            span: options === null || options === void 0 ? void 0 : options.spanId,
            fingerprint: options === null || options === void 0 ? void 0 : options.fingerprint,
            diffMs,
            date: new Date(),
            message,
            args: logArgs.length === 0
                ? undefined
                : logArgs.length === 1
                    ? logArgs[0]
                    : logArgs,
        }),
    ];
    const colorizedFormatter = (message, diffMs, ...logArgs) => (0, colors_1.formatLogArgs)(namespaceColor, `${namespace}${(options === null || options === void 0 ? void 0 : options.spanId) ? `<${options.spanId}>` : ""}`, message, logArgs, diffMs);
    const log = (level, ...logArgs) => {
        var _a;
        const isError = LOG_LEVEL.indexOf(level) >= ERROR_LOG_LEVEL;
        if (!enabled && !isError) {
            return;
        }
        const namespaceWithSpanId = `${namespace}:${options === null || options === void 0 ? void 0 : options.spanId}`;
        const nowMs = performance.now();
        const diffMs = nowMs - ((_a = lastCallTimestamps.get(namespaceWithSpanId)) !== null && _a !== void 0 ? _a : nowMs);
        lastCallTimestamps.set(namespaceWithSpanId, nowMs);
        const message = (Array.isArray(logArgs) ? logArgs[0] : logArgs);
        const extraArgs = Array.isArray(logArgs) ? logArgs.slice(1) : [];
        const formatter = config.ENV === "development" ? colorizedFormatter : jsonFormatter;
        const logger = isError ? console.error : console.log;
        logger(...formatter(message, diffMs, ...extraArgs));
    };
    const logLevelMethods = Object.fromEntries(LOG_LEVEL.map((level) => [
        level,
        (...logArgs) => log(level, ...logArgs),
    ]));
    return Object.assign(logLevelMethods.debug, Object.assign({ extend, span: (identifier, fingerprint) => extend("", Object.assign(Object.assign({}, options), { spanId: identifier, fingerprint })), enabled }, logLevelMethods));
};
exports.debugFactory = debugFactory;
